"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const translate_1 = require("components/translate");
const ModuleSelectItem_1 = __importDefault(require("./ModuleSelectItem"));
const ModuleTypes_1 = require("./ModuleTypes");
const ModuleSelect = ({ t, name, actionType, value, isSubscription, onChange }) => {
    const prefix = 'module_editor.module_select';
    const isUpdate = actionType === 'update';
    const isExtra = value !== ModuleTypes_1.ModuleType.Standard;
    const getDisabledItemTooltip = ({ sourceModule, targetModule, disabled }) => {
        if (isSubscription && targetModule === ModuleTypes_1.ModuleType.Paid) {
            return t(`${prefix}.paid_add_on_tooltip`);
        }
        return disabled
            ? t(`${prefix}.disabled_item_tooltip`, {
                from: t(`${prefix}.${sourceModule}_title`).toLowerCase(),
                to: t(`${prefix}.${targetModule}_title`).toLowerCase()
            })
            : '';
    };
    const MODULE_TYPE_OPTIONS = [
        {
            type: ModuleTypes_1.ModuleType.Standard,
            title: `${prefix}.${ModuleTypes_1.ModuleType.Standard}_title`,
            description: `${prefix}.${ModuleTypes_1.ModuleType.Standard}_description`,
            disabled: isUpdate && isExtra
        },
        {
            type: ModuleTypes_1.ModuleType.Extra,
            title: `${prefix}.${ModuleTypes_1.ModuleType.Extra}_title`,
            description: `${prefix}.${ModuleTypes_1.ModuleType.Extra}_description`,
            disabled: isUpdate && !isExtra
        },
        {
            type: ModuleTypes_1.ModuleType.Paid,
            title: `${prefix}.${ModuleTypes_1.ModuleType.Paid}_title`,
            description: `${prefix}.${ModuleTypes_1.ModuleType.Paid}_description`,
            disabled: (isUpdate && !isExtra) || isSubscription
        }
    ];
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)("div", { className: "_pb-5", children: [(0, jsx_runtime_1.jsx)("label", { className: "hot-form__label _mb-1 _text-2 _text-gray-900 _font-weight-bold", children: t('module_editor.module_select.title') }), t('module_editor.module_select.subtitle')] }), (0, jsx_runtime_1.jsx)("div", { className: "_d-flex _flex-column _flex-lg-row _pb-7", children: MODULE_TYPE_OPTIONS.map(({ title, description, type, disabled }) => ((0, jsx_runtime_1.jsx)(ModuleSelectItem_1.default, { name: name, type: type, title: t(title), description: t(description), tooltip: getDisabledItemTooltip({
                        sourceModule: value,
                        targetModule: type,
                        disabled
                    }), isChecked: value === type, disabled: disabled, onChange: onChange }, type))) })] }));
};
exports.default = (0, translate_1.translate)()(ModuleSelect);
